import { render, staticRenderFns } from "./color_selector.vue?vue&type=template&id=2a7a6ea0"
import script from "./color_selector.vue?vue&type=script&lang=js"
export * from "./color_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports